"use strict";

angular.module("vendor")
.component("productViewSequenceListing", {
    templateUrl: require("./product-view-sequence-listing.component.html"),
    css: [require("./product-view-sequence-listing.component.useable.css")],
    controller: ProductSequenceController,
    controllerAs: "productSequenceCtrl"
});

function ProductSequenceController(
    $scope, $stateParams, $state, $q, Language, ProductOrderSequenceService, FlashBag, gettextCatalog, $timeout,
    ProductSequenceService, ModalService, common, $interval
) {
    var _this = this;

    $scope.hasUnsavedChanges = false;
    $scope.columns = [];
    $scope.columnChoices = [3, 5];
    $scope.rowChoices = [10, 30, 50];
    $scope.column = {number: 5};
    $scope.row = {number: 30};
    $scope.reorganize = {auto: false};
    $scope.orderNumber = {show: true};
    $scope.isPickingOrder = false;
    $scope.pickingOrderSequenceId = null;
    $scope.selectedSequenceId = null;
    $scope.responsive = [{
        breakpoint: 768,
        settings: {
            slidesToShow: 3
        }
    }, {
        breakpoint: 560,
        settings: {
            slidesToShow: 2
        }
    }];

    ProductSequenceService.query().$promise.then(function(data) {
        $scope.sequences = data;
        data.forEach(function(sequence) {
            if (sequence.is_picking_order) {
                $scope.pickingOrderSequenceId = sequence.id;
            }
        });
        $scope.isPickingOrder = $scope.pickingOrderSequenceId === $scope.selectedSequenceId;
    });

    this.fetch = function() {
        $scope.isFetching = true;
        $scope.isPickingOrder = $scope.pickingOrderSequenceId === $scope.selectedSequenceId;
        ProductOrderSequenceService.query(
            $scope.selectedSequenceId
        ).$promise.then(function(data) {
            $scope.columns.length = 0;
            $timeout(function() {
                $scope.isFetching = false;
                generateLists(data);
            });
        });
    };

    this.reorganizeColumns = function() {
        var items = [];
        for (var c = 0; c < $scope.columns.length; c++) {
            for (var r = 0; r < $scope.columns[c].rows.length; r++) {
                items.push($scope.columns[c].rows[r]);
            }
            $scope.columns[c].rows.length = 0;
        }

        var columnsCount = Math.ceil(items.length / $scope.row.number);
        $scope.columns.length = columnsCount;
        for (var c = 0; c < columnsCount; c++) {
            var rowItems = items.slice(c * $scope.row.number, (c + 1) * $scope.row.number);

            if ($scope.columns[c] === undefined) {
                $scope.columns[c] = {rows: []};
            }

            $scope.columns[c].rows.length = rowItems.length;

            for (var r = 0; r < $scope.row.number; r++) {
                if (rowItems[r]) {
                    $scope.columns[c].rows[r] = rowItems[r];
                }
            }
        }
    };

    this.getSlickOptions = function() {
        return {
            swipe: false,
            responsive: $scope.responsive,
            touchMove: false,
            infinite: false,
            slidesToShow: $scope.column.number,
            slidesToScroll: 1,
            prevArrow: ".prev-arrow",
            nextArrow: ".next-arrow",
            initialSlide: 0
        }
    };

    this.updateView = function() {
        $timeout(function() {
            var slickElement = angular.element(".slick");

            if (slickElement[0].slick) {
                angular.element(".slick").slick("unslick");
            }

            _this.reorganizeColumns();
            $timeout(function() {
                slickElement.slick(_this.getSlickOptions());

                $timeout(function() {
                    slickElement.slick("refresh");
                    // delay patch for zero width column bug
                }, 125);
            });
        });
    };

    this.updateSequence = function() {
        $scope.isFetching = true;
        $scope.saveButtonDisabled = true;
        var productIds = [];

        for (var c = 0; c < $scope.columns.length; c++) {
            for (var r = 0; r < $scope.columns[c].rows.length; r++) {
                productIds.push($scope.columns[c].rows[r].id);
            }
        }

        ProductOrderSequenceService.update($scope.selectedSequenceId, productIds).then(function(response) {
            $scope.hasUnsavedChanges = false;
            $scope.columns.length = 0;

            $timeout(function() {
                generateLists(response.data);
                $scope.isFetching = false;
                $scope.saveButtonDisabled = false;
                FlashBag.clearAll();
                FlashBag.success(gettextCatalog.getString("Product order updated."), true);
            });
        }, function(response) {
            $scope.isFetching = false;
            $scope.saveButtonDisabled = false;
            FlashBag.apiError(response);
        });
    };

    this.slidePrev = function() {
        angular.element(".prev-arrow").click();
    };

    this.slideNext = function() {
        angular.element(".next-arrow").click();
    };

    this.getSelectedItems = function(column, item) {
        item.selected = true;
        item.styled = true;

        return column.rows.filter(function(item) {
            return item.selected;
        });
    };

    this.onDragstart = function(column, item, event) {
        column.dragging = true;
        item.selected = true;
        item.styled = true;
    };

    this.onDragEnd = function(column, item, event) {
        column.dragging = false;
    };

    this.onDrop = function(column, rows, index) {
        angular.forEach(rows, function(item) {
            item.selected = false;
        });

        column.rows = column.rows.slice(0, index)
        .concat(rows)
        .concat(column.rows.slice(index));

        $interval(function() {
            angular.forEach(rows, function(item) {
                item.styled = false;
            });
            // this is a delay for animation
        }, 200, 1);

        return true;
    };

    this.setItemSelected = function(item) {
        var itemSelected = !item.selected;

        item.selected = itemSelected;
        item.styled = itemSelected;
    };

    this.reorganizeColumnsWhenAuto = function() {
        if ($scope.reorganize.auto) {
            _this.reorganizeColumns();
        }
    };

    this.onMoved = function(column) {
        $scope.hasUnsavedChanges = true;
        column.rows = column.rows.filter(function(item) {
            return !item.selected;
        });

        this.regenerateIndices();
        this.reorganizeColumnsWhenAuto();
    };

    this.initSlider = function() {
        angular.element(".prev-arrow").on("dragover", onArrowDragOver);
        angular.element(".next-arrow").on("dragover", onArrowDragOver);
    };

    this.regenerateIndices = function() {
        var count = 0;
        for (var c = 0; c < $scope.columns.length; c++) {
            for (var r = 0; r < $scope.columns[c].rows.length; r++) {
                $scope.columns[c].rows[r].index = ++count;
            }
        }
    };

    this.createSequence = function() {
        openSequenceModal(null);
    };

    this.editSequence = function() {
        openSequenceModal($scope.selectedSequenceId);
    };

    function openSequenceModal(sequenceId) {
        ModalService.showModal({
            templateUrl: require("./product-view-sequence-form.modal.html"),
            controller: "ProductViewSequenceFormController",
            controllerAs: "productViewSequenceFormCtrl",
            inputs: {
                $attrs: {
                    sequenceId: sequenceId
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result !== undefined) {
                    ProductSequenceService.query().$promise.then(function(data) {
                        $timeout(
                            function() {
                                $scope.sequences = data;
                                $scope.selectedSequenceId = result;
                                $scope.pickingOrderSequenceId = null;
                                data.forEach(function(sequence) {
                                    if (sequence.is_picking_order) {
                                        $scope.pickingOrderSequenceId = sequence.id;
                                    }
                                });
                                $scope.isPickingOrder = $scope.pickingOrderSequenceId === $scope.selectedSequenceId;
                                _this.fetch();
                            }
                        )
                    })
                }
                modal.element.remove();
            });
        });

    }

    function onArrowDragOver(event) {
        event.currentTarget.click();
    }

    function generateLists(items) {
        if (items.length) {
            for (var c = 0; c <= items.length / $scope.row.number; c++) {
                var rowItems = items.slice(c * $scope.row.number, (c + 1) * $scope.row.number);
                $scope.columns.push({rows: rowItems});
            }
            _this.regenerateIndices();
            $timeout(function() {
                _this.updateView();
                _this.initSlider();
            });
        }
    }

    this.setPickingOrder = function() {
        ProductSequenceService.setPickingOrder($scope.selectedSequenceId).$promise.then(function onSuccess() {
            $scope.pickingOrderSequenceId = $scope.selectedSequenceId;
            FlashBag.success(gettextCatalog.getString("Picking order has been saved successfully."));
        });
    };

    this.exportData = function() {
        ModalService.showModal({
            templateUrl: require("./export-sequence.modal.html"),
            controller: "ExportSequenceModalController",
            controllerAs: "exportSequenceModalCtrl",
            inputs: {
                $attrs: {
                    modalTitle: gettextCatalog.getString("Select sequence to export")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(sequence_id) {
                if (sequence_id !== undefined) {
                    var params = {};
                    if (sequence_id) {
                        params.sequence_id = sequence_id;
                    }
                    ProductOrderSequenceService.exportData(params);
                }
                modal.element.remove();
            });
        });
    };

    this.importData = function() {
        ModalService.showModal({
            templateUrl: require("./import-sequence.modal.html"),
            controller: "ImportSequenceModalController",
            controllerAs: "importSequenceModalCtrl"
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
        });
    };

    this.fetch();
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/product-view-sequence-listing.component.js
// module id = 921
// module chunks = 0